import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { getStripe } from '../services/stripeService';
import STRIPE_CONFIG from '../config/stripe';

const StripeProvider = ({ children, shouldLoadStripe = false }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Defer Stripe.js so /fwd → first checkpoint isn't competing for the connection.
    // Soft-nav keeps this provider mounted, so a single delayed load covers post-/fwd routes.
    const delayMs = shouldLoadStripe ? 0 : 1500;
    const timer = setTimeout(() => {
      try {
        const stripe = getStripe();
        if (stripe) {
          setStripePromise(stripe);
        } else {
          setError('Failed to load Stripe');
        }
      } catch (err) {
        setError(err.message);
      }
    }, delayMs);

    return () => clearTimeout(timer);
  }, [shouldLoadStripe]);

  if (error) {
    return (
      <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
        <h3>Stripe Configuration Error</h3>
        <p>{error}</p>
        <p>Publishable Key: {STRIPE_CONFIG.publishableKey}</p>
        <p>Environment Variable: {process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}</p>
      </div>
    );
  }

  // Always provide Elements context to avoid Stripe hook errors
  // If stripePromise is null, Elements will handle the loading internally
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
